import { useContext } from "react";
import { ToastContext } from "@/components/ui/toastContext";

export function useToast() {
  const ctx = useContext(ToastContext);
  if (ctx === undefined) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return ctx;
}
